import { supabase } from './supabase'

// Stable ordering and exact counts prevent server row limits from silently
// turning partial data into totals. Stop with an error on inconsistent pages.
export async function readAdminRows(table, columns, { state, order = 'id', ascending = true } = {}) {
  const rows = []
  for (let page = 0; page < 10000; page++) {
    let query = supabase.from(table).select(columns, { count: 'exact' })
      .order(order, { ascending })
    if (order !== 'id') query = query.order('id')
    if (state) query = query.eq('state', state)
    const { data, error, count } = await query.range(rows.length, rows.length + 199)
    if (error) throw error
    if (!Array.isArray(data) || !Number.isInteger(count) || count < 0) throw new Error('Invalid database response')
    rows.push(...data)
    if (rows.length >= count) return rows
    if (!data.length) throw new Error('Incomplete database response')
  }
  throw new Error('Too many rows to display; narrow the selection')
}

async function countRows(table) {
  const { count, error } = await supabase.from(table).select('*', { count: 'exact', head: true })
  if (error) throw error
  if (!Number.isInteger(count) || count < 0) throw new Error('Invalid database count')
  return count
}

export async function readAdminStats() {
  const [races, evidence, candidates, positions] = await Promise.all([
    countRows('races'), countRows('candidate_evidence'),
    readAdminRows('candidates', 'id,state'),
    readAdminRows('candidate_positions', 'id,candidate_id'),
  ])
  const candidateIds = new Set(candidates.map(candidate => candidate.id))
  const withPos = new Set(positions.filter(position => candidateIds.has(position.candidate_id)).map(position => position.candidate_id)).size
  const byState = {}
  for (const candidate of candidates) {
    if (candidate.state && candidate.state !== 'XX') byState[candidate.state] = (byState[candidate.state] || 0) + 1
  }
  return { races, evidence, candidates: candidates.length, positions: positions.length, withPos,
    byState: Object.entries(byState).sort((a, b) => b[1] - a[1]) }
}
